/*
Documentation

This file renders the site home page

*/

import HeroHalf from 'components/markup/heros/Half';
import React from "react";
import { Helmet } from 'react-helmet';
import {  Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { architeckCall } from 'database';
import { toggleAlert } from 'store/functions/system';
import archkFormatString from 'architeck-format-string';
import { Link } from 'react-router-dom'
import moment from 'moment';
import { connect } from 'react-redux';

class Category extends React.Component {

    state = {
        posts: [],
        main_post: {}
    }

    componentWillMount = async  () => {

        const category = this.props.match.params.category

        if(this.props.app_articles && this.props.app_articles.length) {

            this.setState({posts: this.props.app_articles.filter(a => a.post_categories.includes(category))})

        } else {

            const posts = await architeckCall({
                method: 'get',
                url: '/api/v1/archk_articles/list/?limit=10&find_by=post_status__published',
            })
    
            if(posts.success) {
                this.setState({posts: posts.data.filter(a => {

                    return a.post_categories.includes(category)

                }), loaded: true})
            } else {
                toggleAlert(true, 'warning', `Error: ${posts.message}.`, 'infinite' )
            }

        }

       
        
    }

    render() {

        const posts = this.state.posts
        const main_post = posts && posts.length ? posts[0] : null
        const other_posts = posts && posts.length ? posts.slice(1, posts.length) : []

        if(!posts) {
            return (

                <div className="py-6 text-center">
                    <h1>No posts found.</h1>
                </div>

            )
        }

                
        return (
        <>

            <Helmet>
                <title>{"Category " + this.props.match.params.category}</title>
                <meta name="description" content={"Category " + this.props.match.params.category} />
            </Helmet>

            <div className="main-content articles">

                {main_post && (
                    <HeroHalf filter={.8} padding={window.innerWidth > 600 ? 100 : 50} theme="dark" img={main_post.post_image}>
                    <Container>
                        <Row>
                            <Col lg={7} mg={7}>

                                <h1 className="display-1 text-white">{main_post.post_name}</h1>

                                <p className="text-muted mb-0 text-sm mt-3">{ moment.unix(main_post.created_at).format("MMM D, YYYY")}</p>

                                <p className="text-white">{main_post.post_excerpt}</p>
                                
                                <div className="mb-3">
                                    <span style={{display: 'inline-block'}} className="mr-3">
                                        <img style={{width: 50, borderRadius: 50, marginTop: -20}} src={main_post.post_author.picture_url} alt="" />
                                    </span>
                                    <span style={{display: 'inline-block', paddingTop: 10}}>
                                        <span className="text-white">
                                            Author <br /> 
                                            <b >{main_post.post_author.given_name} {main_post.post_author.family_name}</b>
                                        </span>
                                    </span>
                                </div>


                                <Link to={`/article/${main_post._id}`}  className="mt-2 btn btn-neutral">Read More</Link>
                            </Col>
                        </Row>

                      
                    </Container>
                </HeroHalf>
                )}
                

                <section className="bg-white section section-lg  py-7 bg-white text-center">
                    <Container >
                        <h1 className="display-2">Category: <b className="text-underline">{this.props.match.params.category}</b></h1>
                     
                    </Container>
                </section>

                <section className="py-6">

                 
                    <Container>
                        <Row>
                            {other_posts && other_posts.length ? other_posts.map(p => (


                                <Col lg={4} className=" raise-2 article-card">
                                    
                                    <Link to={`/article/${p._id}`} >
                                        <div className="image" style={{ backgroundImage: 'url("'+p.post_image+'")'}} />
                                    </Link>

                                    <Card>
                                        <CardHeader style={{minHeight: 90}}>
                                            <h3 className="mb-0">{p.post_name}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <p className="">{archkFormatString(p.post_excerpt, 100, true)}...</p>
                                            <p className="text-sm">By <b>{p.post_author.given_name} {p.post_author.family_name}</b> on { moment.unix(main_post.created_at).format("MMM D, YYYY")}</p>
                                            <Link to={`/article/${p._id}`} className="mt-2 btn btn-success">Read More</Link>
                                        </CardBody>
                                    </Card>

                                </Col>
                            )) : (
                                <Col xs={12} className="text-center">
                                    <h2>There are no more posts found in this category.</h2>
                                    <Link to="/categories" className="text-success"><i className="fas fa-long-arrow-alt-left mr-2"></i> Back To Categories</Link>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </section>


            </div>

        </>
        );
    }
}


  
const mapStateToProps = state => {

    return {
  
      app_articles: state.articles.app_articles,
  
    };
};
  
export default connect(mapStateToProps, '')(Category);